const exp = {
  params: Object.assign({}, { loaded: false, loading: false }),
  entities: {},
  ajaxCallsInProgress: 0,
  notifications: {
    unreadNotifications: 0,
    totalNotifications: 0,
    enabled: true,
    data: Object.assign([], { isLoaded: false })
  },
  pendingAsyncCommands: [],
  snackbar: {
    open: false,
    msg: null,
    type: null
  },
  partners: {
    list: {},
    items: {},
    dealers: {},
    dealerContactModes: {},
    dealerContactInfos: {}
  },
  partnerLogs: {
    list: {},
    items: {}
  },
  properties: {},
  addresses: {
    //"24324": { loaded: true, loading: false, ids: ["12","233","242"]}
  },
  bankAccounts: {},
  activityFields: {},
  consents: {},
  contactInfos: {},
  scoringGrid: {},
  summary: {
    contactInfoSummary: {},
    activityFieldsSummary: {},
    bankAccountsSummary: {},
    partnerAddressesSummary: {},
    shareholdersSummary: {}
  },
  partnerContactModes: {},
  shareholders: {},
  dictionaries: {
    countries: {},
    genderTypes: Object.assign([], { loaded: false }),
    dimensionPeriods: Object.assign([], { isLoaded: false }),
    scoringCategoryOptions: Object.assign([], { isLoaded: false, loading: false })
  },
  dashboard: {
    clientOfferChartData: null,
    clientOfferStatusChartData: null,
    topClientsChartData: null,
    latestClientsChartData: null
  },
  userInfo: { isLoaded: false, loading: false, error: false },
  userRights: Object.assign({}, { data: {}, loaded: false, loading: false }),
  shareholderDetails: {},
  settings: {
    cache: {
      resetting: false
    }
  },
  logsData: {
    logs: {},
    levels: [],
    currentLog: {}
  },
  dealerContactInfos: {}
};
export default exp;
